// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Vj0l","col":"styles_col__1_qAm","fulfillmentStatus":"styles_fulfillmentStatus__1rFCO","emailCol":"styles_emailCol__2bC8U"};